// Centralised site configuration (contacts, brand)
export const SITE = {
  brand: {
    name: "Instituto Leopoldo Guimarães",
    short: "iLg",
    tagline: "Metodologia Cambridge · Centro de Formação DGERT",
    logo: "https://customer-assets.emergentagent.com/job_fbb2907e-92ca-4a47-ad01-ef499595622a/artifacts/f8uaqewf_ilg_logotipo-removebg-preview.png",
  },
  contact: {
    whatsappNumber: "+351912379349",
    whatsappDisplay: "+351 912 379 349",
    whatsappMessage: "Olá! Gostaria de saber mais sobre o Instituto Leopoldo Guimarães.",
    email: "geral@institutolg.com",
    address: "Av. Pedro Nunes nº 16 B, 2635-317 Rio de Mouro",
    schedule: [
      { d: "Segunda a Sexta", h: "07h30 — 19h00" },
      { d: "Sábado e Domingo", h: "Encerrado" },
    ],
    social: {
      instagram: "https://www.instagram.com/instituto_ilg/",
    },
  },
};

export const whatsappLink = () => {
  const text = encodeURIComponent(SITE.contact.whatsappMessage);
  const num = SITE.contact.whatsappNumber.replace(/\D/g, "");
  return `https://wa.me/${num}?text=${text}`;
};
